var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCnc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 21,
    viewBox: "0 0 9 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1723_1002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.80285 0H1.15039V7.69933H7.80285V0Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27418 7.08301H2.68066V13.8691H6.27418V7.08301Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2933 8.73105H0.660791C0.296985 8.73105 0 8.44149 0 8.07026V4.65493C0 4.29113 0.296985 3.99414 0.660791 3.99414H8.2933C8.65711 3.99414 8.95409 4.29113 8.95409 4.65493V8.07026C8.95409 8.44149 8.65711 8.73105 8.2933 8.73105Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95698 14.07H1.99734C1.44792 14.07 1.00244 13.6245 1.00244 13.0751V10.6844C1.00244 10.1349 1.44792 9.68945 1.99734 9.68945H6.96441C7.51383 9.68945 7.95931 10.1349 7.95931 10.6844V13.0751C7.95188 13.6245 7.50641 14.07 6.95698 14.07Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3405 15.0423H2.68759L2.17529 13.2529H6.77856L6.3405 15.0423Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63818 14.4854V20.0612L4.47717 20.9299L5.30872 20.0612V14.4854H3.63818Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1723_1002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.95409,
    height: 20.93,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnc);
export default __webpack_public_path__ + "static/media/cnc.aa3cbb0eafa6be267fa5c998a49d0e23.svg";
export { ForwardRef as ReactComponent };